export enum NotificationTypes {
    CREATE_NOTIFICATION = 'CREATE_NOTIFICATION',
    CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION',
}

export interface INotificationInfo {
    header: string;
    text: string;
    type: "success" | "warning" | "error";
    closeAfterMs?: number;
}
